import PropTypes from "prop-types";
import { useFormContext, useWatch } from "react-hook-form";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { credentialsOf, sameCredentials } from "routes/swoogo/connectionForm";

const TEST_FAILED_MESSAGE = "The connection test failed.";

const TestConnectionControl = ({ isConfigured, testMutation }) => {
  const { setValue } = useFormContext();
  const [apiKey, apiSecret] = useWatch({ name: ["api_key", "api_secret"] });
  const typed = credentialsOf({ api_key: apiKey, api_secret: apiSecret });
  const hasBothValues = Boolean(apiKey && apiSecret);
  // Swoogo charges for every request, so an unchanged test is not repeated.
  const isUnchangedSuccess =
    testMutation.data?.ok && sameCredentials(typed, testMutation.variables);

  const handleTest = () =>
    testMutation.mutate(typed, {
      onSuccess: result => {
        if (result.ok) {
          setValue(
            "folder_ids",
            result.folders
              .filter(folder => folder.is_visible)
              .map(folder => folder.id),
            { shouldDirty: true }
          );
        }
      },
    });

  const resultMessage = testMutation.isError
    ? TEST_FAILED_MESSAGE
    : testMutation.data?.message;

  return (
    <>
      <Button
        type="button"
        variant="outline"
        disabled={
          !(isConfigured || hasBothValues) ||
          testMutation.isPending ||
          isUnchangedSuccess
        }
        onClick={handleTest}
      >
        Test Connection
      </Button>
      {resultMessage && (
        <Alert
          variant={testMutation.data?.ok ? "default" : "destructive"}
          className="tw:w-auto"
        >
          <AlertDescription>{resultMessage}</AlertDescription>
        </Alert>
      )}
    </>
  );
};

TestConnectionControl.propTypes = {
  isConfigured: PropTypes.bool,
  testMutation: PropTypes.shape({
    mutate: PropTypes.func.isRequired,
    isPending: PropTypes.bool,
    isError: PropTypes.bool,
    data: PropTypes.shape({
      ok: PropTypes.bool,
      message: PropTypes.string,
      folders: PropTypes.array,
    }),
    variables: PropTypes.object,
  }).isRequired,
};

export default TestConnectionControl;
